import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META, {
  type WorkspaceAgentGuidedFlowDestination,
  type WorkspaceAgentGuidedFlowEditId,
  type WorkspaceAgentGuidedFlowFormat,
  type WorkspaceAgentTaskSubmittedType,
} from './useTrackAgentTaskSubmitted.meta';
import { withWorkspaceAgentCategory } from './workspaceAgentAnalytics';

export type {
  WorkspaceAgentGuidedFlowDestination,
  WorkspaceAgentGuidedFlowEditId,
  WorkspaceAgentGuidedFlowFormat,
  WorkspaceAgentTaskSubmittedType,
} from './useTrackAgentTaskSubmitted.meta';
export {
  WORKSPACE_AGENT_GUIDED_FLOW_ACTIONS_MENU_TASK_ID,
  WORKSPACE_AGENT_GUIDED_FLOW_DESTINATIONS,
  WORKSPACE_AGENT_GUIDED_FLOW_EDIT_IDS,
  WORKSPACE_AGENT_GUIDED_FLOW_FORMATS,
} from './useTrackAgentTaskSubmitted.meta';

export type WorkspaceAgentGuidedFlowSubmissionParams = {
  destination: WorkspaceAgentGuidedFlowDestination;
  edit_id: WorkspaceAgentGuidedFlowEditId;
  format: WorkspaceAgentGuidedFlowFormat;
  has_suffix: boolean;
};

type WorkspaceAgentTaskSubmittedSharedParams = {
  contains_skill: boolean;
  session_id: string;
  skill_count: number;
  skill_ids?: string[];
};

export type UseTrackAgentTaskSubmittedParams = WorkspaceAgentTaskSubmittedSharedParams &
  (
    | ({
        actions_menu_task_id?: string;
        type: 'guided_flow';
      } & WorkspaceAgentGuidedFlowSubmissionParams)
    | {
        actions_menu_task_id?: string;
        type: Exclude<WorkspaceAgentTaskSubmittedType, 'guided_flow'>;
      }
  );

export const useTrackAgentTaskSubmitted = () => {
  const { track } = useAnalyticsUtilities();

  const trackAgentTaskSubmitted = useCallback(
    (params: UseTrackAgentTaskSubmittedParams) => {
      track(META.name, withWorkspaceAgentCategory(params));
    },
    [track],
  );

  return { trackAgentTaskSubmitted };
};
